<template>
    <v-overlay :value="snackbarVisibilityState" :z-index="9999">
        <v-snackbar
            :value="snackbarVisibilityState"
            color="error"
            @input="deactivateSnackbar"
            :top=true
            :timeout=3000
        >
            Access denied.
        </v-snackbar>
    </v-overlay>
</template>

<script>
    import store from "../../store"

    export default {
        name: "Overlay",

        computed: {

            snackbarVisibilityState() {
                return store.state.snackbarVisibility
            },

        },

        methods: {
            deactivateSnackbar() {
                store.commit('deactivateSnackbar');
            }
        }
    }
</script>

<style scoped>

</style>
